(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["netcarat-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-netcarat-faq]').forEach(root => {
    if (root.dataset.faqReady) return;
    root.dataset.faqReady = 'true';
    const search = root.querySelector('[data-faq-search]');
    const clear = root.querySelector('[data-faq-clear]');
    const groups = [...root.querySelectorAll('[data-faq-group]')];
    const links = [...root.querySelectorAll('[data-faq-category]')];
    const result = root.querySelector('[data-faq-result]');
    const empty = root.querySelector('[data-faq-empty]');
    let category = 'all';
    const normalize = text => text.toLocaleLowerCase().replace(/\s+/g, ' ').trim();
    const entries = groups.map(group => ({group, questions: [...group.querySelectorAll('[data-faq-question]')].map(node => ({node, text: normalize(node.textContent)}))}));
    function filter() {
      const query = normalize(search.value);
      let count = 0;
      entries.forEach(entry => {
        let visible = 0;
        entry.questions.forEach(question => {
          const match = (category === 'all' || category === entry.group.dataset.faqGroup) && question.text.includes(query);
          question.node.hidden = !match;
          if (match) { count++; visible++; }
        });
        entry.group.hidden = visible === 0;
      });
      links.forEach(link => {
        const active = link.dataset.faqCategory === category;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
      });
      clear.hidden = !search.value;
      empty.hidden = count > 0;
      result.textContent = query || category !== 'all' ? count + (count === 1 ? ' answer found' : ' answers found') : '';
    }
    root.querySelector('[data-faq-search-wrap]').hidden = false;
    search.addEventListener('input', filter);
    clear.addEventListener('click', () => { search.value = ''; filter(); search.focus(); });
    links.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      category = link.dataset.faqCategory;
      filter();
    }));
    root.querySelector('[data-faq-reset]').addEventListener('click', () => { category = 'all'; search.value = ''; filter(); search.focus(); });
    filter();
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();

  } catch(e) { console.error(e); }
})();
})();
